import React, { useEffect } from 'react';

import styled from 'styled-components';

import { importScript } from './scriptImporter';

const DonationWidgetContainer = styled.div`
  width: 90%;
  max-width: 920px;
  margin: 2rem auto;
`;

export const DonationWidget = ({ id }) => {
  useEffect(() => {
    const callback = function () {
      //eslint-disable-next-line
      bbox.showForm(id);
    };

    importScript('bboxInit', 'https://bbox.blackbaudhosting.com/webforms/bbox-min.js', callback);
  });

  return (
    <DonationWidgetContainer>
      <div id="bbox-root" />
    </DonationWidgetContainer>
  );
};
